// src/pages/Pickup/WalmartPickup.js
import React, {useState} from "react";
import { Icon, Spin } from "antd";
import Header from "../../components/Header";
import Barcode from "./Barcode";
import HelpHeader from "../HelpHeader";
import { colors } from "../Colors";

function WalmartPickup({
    recoilStates,
    fee,
    cancelCashReq,
    isApiLoading,
    barcodeData,
    barcodeError,
    t,
    cashReqDto,
}) {
    const findDirections = () => {
        const address = recoilStates.merchantAddressState.state;
        if (address) {
            const dUrl = `https://www.google.com/maps/dir/?api=1&destination=${encodeURIComponent(
                address
            )}`;
            window.open(dUrl, "_blank");
        }
    };

    // ---------- shared right-side info panel ----------
    const InfoPanel = ({ showPin }) => (
        <div className="flex-item">
            <div className="location-info" style={{ border: "1px solid #ddd" }}>
                <div>
                    <div
                        style={{
                            display: "flex",
                            flexDirection: "row",
                            justifyContent: "center",
                        }}
                    >
                        <img
                            src="/images/Walmart-Logo.png"
                            alt="Walmart"
                            style={{ maxHeight: "100px" }}
                        />
                        <p style={{paddingTop: "20px"}}>®</p>
                    </div>
                </div>
                <div className="walmart-address">
                    <p onClick={findDirections}>
                        {recoilStates.merchantAddressState.state}
                    </p>
                </div>
            </div>

            <div className="info-container">
                <div className="info-header">
                    <h4>{t("pickup:pickup_amount")}</h4>
                    <h4>${recoilStates.amountState.state}</h4>
                </div>
                <div className="walmart-fee">
                    <p>{t("pickup:fee")}</p>
                    <p>${fee}</p>
                </div>
            </div>

            {showPin && (
                <div
                    className="location-info"
                    style={{ border: "1px solid #ddd", marginTop: "5px" }}
                >
                    <div>
                        <h4 style={{ fontWeight: "bold" }}>
                            {t("pickup:pin_label")} {cashReqDto.pin}
                        </h4>
                    </div>
                </div>
            )}
        </div>
    );

    return (
        <div className="withdrawl-page">
            <Header />
            <div className="container withdrawl">
                <div className="spare-dvs align-items-start">
                    <div className="w-100 float-left">
                        <div className="withdrawl-information">
                            <div
                                style={{
                                    position: "relative",
                                    marginBottom: "20px",
                                    textAlign: "center",
                                    width: "100%",
                                }}
                            >
                                <h2>{t("pickup:title")}</h2>
                                <HelpHeader />
                            </div>
                            <div
                                className="withdrawl-qr"
                                style={{
                                    display: "flex",
                                    flexDirection: "column",
                                    alignItems: "center",
                                    justifyContent: "center",
                                }}
                            >
                                <InfoPanel showPin={false} />
                                <h4
                                    style={{ margin: "10px 0px", fontSize: "12px" }}
                                    dangerouslySetInnerHTML={{
                                        __html: t("pickup:instructions_walmart"),
                                    }}
                                />
                                <Spin
                                    spinning={isApiLoading}
                                    indicator={
                                        <Icon
                                            type="loading"
                                            style={{ fontSize: 50, color: "#94220d" }}
                                        />
                                    }
                                >
                                    <div className="pickup-container">
                                        <div className="flex-item qr">
                                            <div className="content-box-barcode barcode-white">
                                                {barcodeData ? (
                                                    <>
                                                        <div className="barcode-quiet-zone">
                                                            <Barcode
                                                              value={JSON.stringify(barcodeData)}
                                                              forceLandscape={false}
                                                            />
                                                        </div>
                                                        <p style={{ marginTop: 10 }}>
                                                            {t("pickup:bring_id")}
                                                        </p>
                                                        <div
                                                            style={{
                                                                marginTop: 10,
                                                                marginBottom: 10,
                                                                fontSize: 13,
                                                                textAlign: "center",
                                                            }}
                                                        >
                                                            <p style={{ fontWeight: "bold", fontSize: "10px" }}>
                                                                {t("pickup:disclaimer_label")}
                                                            </p>
                                                            <p style={{ fontSize: "10px" }}>{t("pickup:disclaimer_fee")}</p>
                                                            <p style={{ fontSize: "10px" }}>{t("pickup:disclaimer_receipt")}</p>
                                                        </div>
                                                    </>
                                                ) : barcodeError ? (
                                                    <p style={{ color: "red" }}>{barcodeError}</p>
                                                ) : (
                                                    <p style={{ color: "#888", padding: "5px" }}>
                                                        {t("pickup:loading_barcode")}
                                                    </p>
                                                )}
                                            </div>
                                        </div>
                                    </div>
                                </Spin>

                                <div className="withdrawl-actions">
                                    {/* No QR button for Walmart */}
                                    <button
                                        className="cancel-button btn"
                                        onClick={cancelCashReq}
                                    >
                                        {t("pickup:cancel_pickup")}
                                    </button>
                                </div>
                            </div>
                        </div>

                        <div className="walmart-legal">
                            <p>
                                {t("pickup:walmartLegal")}
                            </p>
                        </div>
                    </div>
                </div>
            </div>
        </div>
    );
}

export default WalmartPickup;
